/* PlayAh: Mua ngay button → AJAX add to cart, then redirect to /cart */
(function() {
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-playah-mua-ngay]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const form = btn.closest('form[action*="/cart/add"], form[action="/cart/add"]');
    if (!form) {
      // Fallback: just redirect to /cart
      window.location.href = '/cart';
      return;
    }
    const origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Đang thêm…';
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Không thêm được sản phẩm');
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error('[PlayAh Mua ngay]', err);
      alert('Không thêm được sản phẩm: ' + err.message);
      btn.disabled = false;
      btn.textContent = origText;
    }
  });
})();
